<div *hasPermissions='[permissionType.AssignOrUnassignClientAffiliates]'>
  <button class="btn btn-lg bg-white float-right" (click)="openAddModal()"><i
      class="align-middle fas fa-plus-circle"></i> Add Affiliates </button>
</div>
<div class="case-table table-responsive" *blockUI="'container-blockui-affiliates'">
  <div>
    <table class="neu-table table table-striped neu-table w-100" datatable [dtOptions]="dtOptions" data-page="2">
    </table>
  </div>
</div>